// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"ContentCreatorCourses_videoWrapper__1sJ4q","coursesWrapper":"ContentCreatorCourses_coursesWrapper__11o6S"};